import React from 'react' //{useState}
import GetOrdenCompra from '../../modules/custom/accounts/Billing/components/GetOrden'
import GetFacturasEmitidas from '../../modules/custom/accounts/Billing/components/FacturasEmitidas'
import GetResumenconsumo from '../../modules/custom/accounts/Billing/components/ResumenDeConsumo'
import ModalSwal from '../../modules/permisoDenegado/Modalswal'
import { useAppSelector } from '../../../redux/hooks'
const Billing: React.FC = () => {


  return (
    <div className="d-flex flex-row ">
      <div className="d-flex flex-column flex-row-fluid">
          <div className="row  gx-xl-10 ">
              <div className="col-xl-6   ">
                  <GetOrdenCompra ></GetOrdenCompra>
                  <br />
              </div>
              
              <div className=" col-xl-6  ">
                  <GetFacturasEmitidas ></GetFacturasEmitidas>
                  <br />
                  <GetResumenconsumo></GetResumenconsumo>

              </div>
              
          </div>
          
      </div>
    </div>
  )
}

export {Billing}
